import { render } from "./Index.vue?vue&type=template&id=4ded589a&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=4ded589a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1198/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ded589a"]])

export default __exports__